
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'PasswordRequirements',
  props: {
    password: {
      type: String,
      default: ''
    },
    showErrors: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    requirementTests(): { text: string; test: boolean }[] {
      return [
        {
          text: 'utils:PasswordRequirements.8CharsMinimum',
          test: this.password.length >= 8
        },
        {
          text: 'utils:PasswordRequirements.oneUpperCase',
          test: /[A-Z]/.test(this.password)
        },
        {
          text: 'utils:PasswordRequirements.oneDigit',
          test: /\d/.test(this.password)
        },
        {
          text: 'utils:PasswordRequirements.oneLowerCase',
          test: /[a-z]/.test(this.password)
        }
      ];
    }
  }
});
